// extracted by mini-css-extract-plugin
export default {"reqTitle":"ChangePassword_reqTitle__L3bZj","reqList":"ChangePassword_reqList__a+cmC"};